/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Everything_StudentInputs */

const en_pricing_feature_everything_student = /** @type {(inputs: Pricing_Feature_Everything_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything in Student`)
};

const de_pricing_feature_everything_student = /** @type {(inputs: Pricing_Feature_Everything_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles im Studentenplan`)
};

const fr_pricing_feature_everything_student = /** @type {(inputs: Pricing_Feature_Everything_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout dans le plan Étudiant`)
};

const es_pricing_feature_everything_student = /** @type {(inputs: Pricing_Feature_Everything_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo en el plan Estudiante`)
};

const it_pricing_feature_everything_student = /** @type {(inputs: Pricing_Feature_Everything_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutto incluso nel piano Studente`)
};

const nl_pricing_feature_everything_student = /** @type {(inputs: Pricing_Feature_Everything_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles in Student`)
};

const pl_pricing_feature_everything_student = /** @type {(inputs: Pricing_Feature_Everything_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystko w planie dla studentów`)
};

const fi_pricing_feature_everything_student = /** @type {(inputs: Pricing_Feature_Everything_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaikki opiskelijasuunnitelmassa`)
};

const da_pricing_feature_everything_student = /** @type {(inputs: Pricing_Feature_Everything_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alt i Studerende`)
};

const sv_pricing_feature_everything_student = /** @type {(inputs: Pricing_Feature_Everything_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allt i Student`)
};

/**
* | output |
* | --- |
* | "Everything in Student" |
*
* @param {Pricing_Feature_Everything_StudentInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_everything_student = /** @type {((inputs?: Pricing_Feature_Everything_StudentInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Everything_StudentInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_feature_everything_student(inputs)
	if (locale === "fr") return fr_pricing_feature_everything_student(inputs)
	if (locale === "es") return es_pricing_feature_everything_student(inputs)
	if (locale === "it") return it_pricing_feature_everything_student(inputs)
	if (locale === "nl") return nl_pricing_feature_everything_student(inputs)
	if (locale === "pl") return pl_pricing_feature_everything_student(inputs)
	if (locale === "fi") return fi_pricing_feature_everything_student(inputs)
	if (locale === "da") return da_pricing_feature_everything_student(inputs)
	if (locale === "sv") return sv_pricing_feature_everything_student(inputs)
	return en_pricing_feature_everything_student(inputs)
});